// Bridge Contract ABI
export const BRIDGE_ABI = [
  {
    "inputs": [
      { "internalType": "uint8", "name": "destinationChainID", "type": "uint8" },
      { "internalType": "bytes32", "name": "resourceID", "type": "bytes32" },
      { "internalType": "bytes", "name": "data", "type": "bytes" }
    ],
    "name": "deposit",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "handler", "type": "address" },
      { "internalType": "bytes32", "name": "resourceID", "type": "bytes32" },
      { "internalType": "address", "name": "tokenAddress", "type": "address" }
    ],
    "name": "adminSetResource",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_fee",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }],
    "name": "_chainID",
    "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint8", "name": "destinationChainID", "type": "uint8" },
      { "indexed": false, "internalType": "bytes32", "name": "resourceID", "type": "bytes32" },
      { "indexed": false, "internalType": "uint64", "name": "depositNonce", "type": "uint64" }
    ],
    "name": "Deposit",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint8", "name": "originChainID", "type": "uint8" },
      { "indexed": false, "internalType": "uint64", "name": "depositNonce", "type": "uint64" },
      { "indexed": false, "internalType": "enum Bridge.ProposalStatus", "name": "status", "type": "uint8" },
      { "indexed": false, "internalType": "bytes32", "name": "dataHash", "type": "bytes32" }
    ],
    "name": "ProposalEvent",
    "type": "event"
  }
] as const;

